import { FontWeight } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      marginTop: 40,
      background: '#fff',
    },
    heading: {
      color: '#5A00EE',
      fontSize: 60,
      fontWeight: FontWeight.Medium,
      lineHeight: '70px',
      marginBottom: 24,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 36,
        lineHeight: '48px',
      },
    },
    similar: {
      marginBottom: 0,
      padding: 0,
      paddingBottom: 32,
    },
    reviewSnippet: {
      background: 'var(--x-bg-1)',
      margin: [40, 0, 0, 0],
    },
  }),

  { name: 'Static' },
);

export default useStyles;
